export default "/images/mellat.png?bdd15ad4dc9b7cd4d4e1c47b3404a623";